var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"id":"middle"}},_vm._l((_vm.cards),function(card,idx){return _c('g',{key:idx,attrs:{"transform":card.transform}},[_c('DoKoCard',{attrs:{"name":card.name}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }